// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1936":"css/admin-app.7012","2006":"css/app.7012"}[chunkId] + ".css";
};